module.exports = __webpack_public_path__ + "fonts/icomoon.8bbd23a66e82c3aaf9ae749dc02fe92c.woff";